module.exports = __webpack_public_path__ + "static/media/architicting.a0889dbf.jpg";